module.exports = __webpack_public_path__ + "media/images/v1Tag-5561e266f473aaf9ee1a59356c91743d.svg";